"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Logger = _interopRequireDefault(require("../../shared/Logger"));

var _enum = require("../../shared/enum");

var _send = _interopRequireDefault(require("./send"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var logger = new _Logger["default"]('scout:track');
/**
 * init track
 *
 * @param {*} scout
 */

function init(scout) {
  scout.track = function (eventType, eventParams) {
    var store = scout.getStore(); // 校验发送的事件类型是否是 scout 要求的事件类型枚举里面
    // if (!eventTypes.includes(eventType)) {
    //   throw new Error(`${eventType} is not a supported event types`);
    // }

    var params = Object.assign({}, store.baseData, eventParams);

    if (scout.options.noConsole !== true) {
      logger.info("\n".concat(eventType, " => "), JSON.stringify(params, null, ' '));
    } // 非测试模式则上报数据


    !scout.options.testMode && (0, _send["default"])(eventType, params);
  };
}

var _default = {
  init: init,
  name: 'track'
};
exports["default"] = _default;